import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IconComponent } from '../../../shared/icon/icon.component';
import { ProductCardList } from '../../types';

@Component({
    standalone: true,
    templateUrl: 'explore-products.component.html',
    selector: 'global-home-explore-products',
    imports: [CommonModule, IconComponent],
    styleUrls: ['../../../styles.scss', '../product-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class ExploreProductsComponent {
    @Input() exploreProductList!: ProductCardList[];

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    public newTabSvg = (require('!!raw-loader?!../../../assets/icons/new-tab.svg') as { default: string }).default;
}
